import ManualPayment from './ManualPayment';

export default ManualPayment;
